import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Agenda2Cell } from "@treeosk/common";
import queries from "../../../queries";
import SpecificCellPreview from "./SpecificCellPreview";

class Agendas2CellPreview extends React.Component {

    render() {
        const { cell } = this.props;
        const defaultRender = () => <FontAwesomeIcon icon={'calendar-alt'} />;

        return (
            <SpecificCellPreview
                cell={cell}
                defaultRender={defaultRender}
                query={queries.cells.agendas2.get}
                renderingCondition={() => true}
            >
                {(agenda2Cell) => <Agenda2Cell preview={true} cell={agenda2Cell} />}
            </SpecificCellPreview>
        );
    }

}

export default Agendas2CellPreview;
